import { useState } from 'react';
import axios from 'axios';
import { CalendarClock, Check } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SEDI = [
  { value: 'valeggio', label: 'Valeggio sul Mincio' },
  { value: 'verona', label: 'Verona' },
  { value: 'peschiera', label: 'Peschiera del Garda' },
];
const toLocalInput = (iso) => {
  if (!iso) return '';
  const d = new Date(/[zZ]|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const AppointmentField = ({ pratica, onSaved }) => {
  const [value, setValue] = useState(toLocalInput(pratica.appuntamento));
  const [saved, setSaved] = useState(false);
  const [sede, setSede] = useState(pratica.sede || '');
  const put = async (body) => {
    await axios.put(`${API}/admin/pratiche/${pratica.id}`, body,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
    onSaved();
  };
  const save = () => {
    if (value && value !== toLocalInput(pratica.appuntamento)) put({ appuntamento: new Date(value).toISOString() });
  };
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm mb-4" data-testid={`pratica-appointment-${pratica.id}`}>
      <CalendarClock className="w-4 h-4 text-[#C9A227] shrink-0" />
      <span className="text-slate-400 whitespace-nowrap">Appuntamento firma</span>
      <input type="datetime-local" value={value} onChange={(e) => setValue(e.target.value)} onBlur={save}
        className="flex-1 min-w-[180px] border border-slate-200 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-[#4A5FC1]"
        data-testid={`pratica-appointment-input-${pratica.id}`} />
      <select value={sede} onChange={(e) => { setSede(e.target.value); put({ sede: e.target.value }); }}
        className="border border-slate-200 rounded-md px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-[#4A5FC1]"
        data-testid={`pratica-sede-select-${pratica.id}`}>
        <option value="">Sede non indicata</option>
        {SEDI.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
      </select>
      {saved && <Check className="w-4 h-4 text-green-600" data-testid={`pratica-appointment-saved-${pratica.id}`} />}
      {pratica.appt_response && (
        <span title={pratica.appt_note || ''} data-testid={`pratica-appt-response-${pratica.id}`}
          className={`text-[11px] px-2 py-0.5 rounded-full ${pratica.appt_response === 'confermato' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
          {pratica.appt_response === 'confermato' ? 'Confermato dal cliente' : 'Da spostare'}
        </span>
      )}
    </div>
  );
};
